<template>
  <v-list-item style="height: 45px" class="px-2 hover-list-element">
    <v-list-item-content>
      <v-list-item-title class="d-flex align-center flex-nowrap">
        <v-tooltip color="font" bottom v-if="singleLogin && isUsers && is_logged_id">
          <template #activator="{ on }">
            <v-icon color="success" v-on="on">
              mdi-circle-medium
            </v-icon>
          </template>
          <span>{{ $i18n.t('admin.userActive') }}</span>
        </v-tooltip>
        <div
          v-if="isUsers"
          class="text-truncate text-body-2 pr-3 flex-shrink-0"
          :class="{ 'text--disabled': blocked }"
          style="max-width: 60%"
        >
          {{ name }}
        </div>
        <v-tooltip bottom color="font" v-if="blocked && isUsers">
          <template #activator="{ on }">
            <v-icon class="pr-3" v-on="on" style="font-size: 19px">
              mdi-lock
            </v-icon>
          </template>
          {{ $i18n.t('admin.userBlocked') }}
        </v-tooltip>
        <v-chip
          v-if="group"
          :color="color"
          small
          :class="{ 'white--text': !isColorLight, 'font--text': isColorLight, 'chip--outlined': isColorWhite }"
          style="height: 20px"
        >
          <div class="text-truncate">
            {{ group }}
          </div>
        </v-chip>
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="items">
      <dots-menu font-size="19px" :items="items" v-on="$listeners"> </dots-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'UsersInputListItem',
  components: {
    DotsMenu,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    group: {
      type: String,
      default: null,
    },
    isUsers: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      default: null,
    },
    blocked: {
      type: Boolean,
      default: false,
    },
    isGroups: {
      type: Boolean,
      default: false,
    },
    singleLogin: {
      type: Boolean,
    },
    is_logged_id: {
      type: Boolean,
    },
  },
  computed: {
    groupsColumnCols() {
      return this.isGroups ? 'auto' : '8';
    },
    isColorLight() {
      return this.$_isHexColorLight(this.color);
    },
    isColorWhite() {
      return this.$_getHexColorBrightness(this.color) > 250;
    },
  },
};
</script>

<style lang="scss" scoped>
.chip--outlined {
  border: 1px solid grey !important;
}
.v-list-item {
  @include border(top);
  @include border(left);
  @include border(right);
  &:last-child {
    @include border(bottom);
  }
}
</style>
